/*
  merged-filters.js

  Collection and search filters render one option per normalized value. The spelling
  variants that option also covers sit beside it as disabled hidden inputs, so they
  stay out of the querystring until the option is actually checked. Keep the
  normalize() rule below in sync with the "normalizer" blocks in
  snippets/collection-sidebar.liquid and snippets/collection-grid-filters.liquid.
*/
(function () {
  // Spelling variants that fold together. Keep this table identical to the
  // filter_aliases list at the top of the filter snippets.
  var ALIASES = {
    "racedediee::bouldogue": "racedediee::bouledogue",
    "racedediee::bouldoguefrançais": "racedediee::bouledoguefrançais",
    "racedediee::labadorretriever": "racedediee::labradorretriever",
    "racedediee::terreiryorkshire": "racedediee::terrieryorkshire",
    "racedediee::maincoon": "racedediee::mainecoon",
    "soinsbesoin::peauetestomacssensible": "soinsbesoin::peauetestomacsensible",
    "fontionnelles": "gâteriesfonctionnelles",
    "stadedevie::chiot": "stadedevie::chiots",
    "stadedevie::chienadulte": "stadedevie::chiensadultes",
    "stadedevie::chatadulte": "stadedevie::chatsadultes",
    "stadedevie::sénior": "stadedevie::chiensséniors",
    "lyophilisée": "gâterieslyophilisés",
    "colliers": "colliersetharnais",
    "laissesetharnais": "colliersetharnais",
    "stadedevie::chienadulteetsénior": "stadedevie::chiensadultesetséniors"
  };

  function normalize(value) {
    var key = String(value).toLowerCase().trim().replace(/,/g, ".").replace(/\s+/g, "").replace(/&amp;/g, "et").replace(/&/g, "et");
    return ALIASES[key] || key;
  }

  // Send every spelling the checked option stands for, and nothing while it is off.
  function syncVariants(checkbox) {
    var label = checkbox.closest("label");
    if (!label) return;
    var variants = label.querySelectorAll("input.tag__input-merged");
    for (var i = 0; i < variants.length; i++) {
      variants[i].disabled = !checkbox.checked;
    }
  }

  document.addEventListener("change", function (event) {
    try {
      var input = event.target;
      if (!input || input.nodeName !== "INPUT") return;
      if (!input.hasAttribute("data-merged-filter")) return;
      syncVariants(input);
    } catch (e) {}
  }, true);

  // A merged option shows one chip, so removing it has to drop every spelling in the
  // group. Shopify's url_to_remove only drops one, so correct the link before the
  // theme follows it.
  document.addEventListener("click", function (event) {
    try {
      if (!event.target.closest) return;
      var chip = event.target.closest("li.tag--remove");
      if (!chip) return;
      var link = chip.querySelector("a[data-merged-filter-key]");
      if (!link) return;
      var name = link.getAttribute("data-merged-filter-name");
      var key = link.getAttribute("data-merged-filter-key");
      var kept = new URLSearchParams();
      new URLSearchParams(window.location.search).forEach(function (value, param) {
        if (param === name && normalize(value) === key) return;
        kept.append(param, value);
      });
      var query = kept.toString();
      link.setAttribute("href", window.location.pathname + (query ? "?" + query : ""));
    } catch (e) {}
  }, true);
})();
